import React, { useEffect, useRef, useState, useMemo } from "react";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../../config/axios";
import { formatDate, formatDateTime, formattedDate, formattedDateLong } from "../Date";
import usePermission from "../../config/permissions";
import { ToastContainer, toast } from "react-toastify";
import { customSortByKey, DateRangePicker, downloadAsExcel, FormatKey, handleErrorToast, ViewDynamicApprovalRemarks, ViewDynamicApprovalStatus, ViewFile } from "../CustomFunctions";
import { CircularGrid, DeleteDustbin, DownloadIcon, Filter, AddwithWhiteCircle } from "../AllSvg";
import { BankDetailChangeLogDelete } from "./EmployeeManagementComponents";
import { ViewAppraisalDetailsByEmployee } from "../AppraisalManagement/AppraisalComponents";
import { DeleteCompoffShortLeaveForm, AddCompoffShortLeaveForm } from "../workforcemanagement/RequestManagementComponents";
import dayjs from "dayjs";
import { MonthRangePicker, getOrdinal } from "../CustomFunctions";
import Loader from "../Loader";
import { CustomImageModal } from "../CustomFunctions";
import UserDefaultLogo from "../UserDetails/UserDefaultLogo";
// import { StarIco}

const StarIcon = ({ fillPercentage, id, size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id={`grad-${id}`} x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset={`${fillPercentage}%`} stopColor="#FFC107" />
                <stop offset={`${fillPercentage}%`} stopColor="#f0eded" />
            </linearGradient>
        </defs>
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill={`url(#grad-${id})`} stroke="" strokeWidth="1" />
    </svg>
);

const getCurrentMonthYear = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
};

// const EmployeeCompensatoryLogTable = ({ emp_code }) => {
//     const { PORTAL_SETTINGS, SUPER_ADMIN, SUB_COMPANIES, PERMISSION_HR_ADMIN } = usePermission();
//     const [checkedItems, setCheckedItems] = useState([]);
//     // const [date, setDate] = useState();
//     const [buffer, setBuffering] = useState(true); //buffering logic
//     // const [date, setDate] = useState(`${formattedDate}`);
//     const [fromdate, setFromDate] = useState("null");
//     const [todate, setToDate] = useState("null");
//     const [selectedStatus, setSelectedStatus] = useState("null");
//     const [employeeGet, setEmployeeGet] = useState("null");
//     const [active, setActive] = useState("active");
//     const [selectedDivision, setDivision] = useState(
//         `${sessionStorage.getItem("company_id")}`
//     );

//     // *********** Employee Details Api Start ***********
//     const [leaveLogList, setLeaveLogList] = useState([]);
//     const [filteredleaveLogList, setfilteredleaveLogList] = useState([]);

//     const getLeaveLogList = async () => {
//         setBuffering(true); //buffering logic // Start Buffering
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/wfm/shortandcompoff/${fromdate}/${todate}/null/${selectedStatus}/${emp_code}/null/active/`
//             );
//             setLeaveLogList(res.data);
//             // setOutdutyName(res.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false); //buffering logic // End Buffering
//         }
//     };

//     // *********** Employee Details Api End ***********

//     useEffect(() => {
//         getLeaveLogList();
//     }, [employeeGet, fromdate, todate, selectedStatus, active, selectedDivision]);


//     return (
//         <>
//             <div className="attendance-history-cont">
//                 <div className="attendance-heading  font-weight500    font-size-heading"> </div>
//                 <div className="table-css-white-background">
//                     <div className="table-heading-flex">
//                         <div className="repo-heading font-weight500    font-size-heading">Employee Compensatory Logs </div>
//                         <div className="field-cont">
//                             {/* <DateRangePicker
//                                 startDate={fromdate}
//                                 endDate={todate}
//                                 placeHolder1="From Date"
//                                 placeHolder2="To Date"
//                                 onChange={(start, end) => {
//                                     setFromDate(start);
//                                     setToDate(end);
//                                 }} /> */}

//                             <div className="table-searchh dropdown-container field-cont-div">
//                                 <Filter />
//                                 <select
//                                     className="dropdown font-size-subheading"
//                                     type="text"
//                                     value={selectedStatus}
//                                     onChange={(e) => setSelectedStatus(e.target.value)}
//                                 >
//                                     <option value="null">All</option>

//                                     <option value="pending">Pending</option>
//                                     <option value="approved">Approved</option>
//                                     <option value="rejected">Rejected</option>
//                                 </select>
//                             </div>
//                             {/* {(PORTAL_SETTINGS?.compoff_auto_apply && PORTAL_SETTINGS?.shortleave_auto_apply) && ( */}
//                             {(!PORTAL_SETTINGS?.compoff_auto_apply || !PORTAL_SETTINGS?.shortleave_auto_apply) && (
//                                 <div className="btn-cont" style={{ width: 'max-content' }}>
//                                     <AddCompoffShortLeaveForm getCompensatoryList={getLeaveLogList} SUPER_ADMIN={SUPER_ADMIN} SUB_COMPANIES={SUB_COMPANIES} EmpCode={emp_code} PERMISSION_HR_ADMIN={PERMISSION_HR_ADMIN} PORTAL_SETTINGS={PORTAL_SETTINGS} />
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                     <table className="table-css">
//                         <thead>
//                             <tr className="custom-table-head-tr">
//                                 <th className="align-left">Sr.no</th>
//                                 <th className="align-center">Date</th>
//                                 <th className="align-center">Time (Work Duration)</th>
//                                 <th className="align-center">Reporting Head</th>
//                                 <th className="align-center">Leave Type</th>
//                                 <th className="align-center">Request Status</th>
//                                 <th className="align-center ">Status</th>
//                                 <th className="align-center ">Remark</th>
//                                 {SUPER_ADMIN && <th className="align-center ">Action</th>}
//                             </tr>
//                         </thead>
//                         {buffer ? (
//                             <div className="spinner"></div>
//                         ) : (
//                             <tbody>
//                                 {leaveLogList.map((i, index) => (
//                                     <React.Fragment key={index}>
//                                         <tr className="tr-border-bottom">
//                                             <td colSpan="6"></td>
//                                         </tr>
//                                         <tr className="custom-table-head-td">
//                                             <td className="align-left">{index + 1}</td>
//                                             <td className="align-center">{formattedDateLong(i.date)}</td>
//                                             <td className="align-center">{i.in_time}-{i.out_time}({i.work_duration})</td>
//                                             <td className="align-center">{i.rh_assigned}</td>
//                                             <td className="align-center text-capitalize">{i.duration}</td>
//                                             <td className="align-center">
//                                                 <span
//                                                     request-status={i.rh_leave_status}
//                                                     className="request-status align-center"
//                                                 >
//                                                     {i.rh_leave_status === "pending"
//                                                         ? "Pending For Rh Approval ⌛"
//                                                         : i.rh_leave_status === "rejected"
//                                                             ? "Rh Rejected ✖, "
//                                                             : "Rh Approved ✔, "}
//                                                 </span>
//                                             </td>
//                                             <td className="align-center">
//                                                 {i.approval_flow_version === 0
//                                                     ?
//                                                     'Legacy Request'
//                                                     :
//                                                     (
//                                                         <ViewDynamicApprovalStatus dynamic_approval={i?.dynamic_approval} />
//                                                     )
//                                                 }
//                                             </td>

//                                             <td className="table-body width-15vw align-center vertical-alignment-middle" >
//                                                 {i?.approval_flow_version === 0
//                                                     ?
//                                                     'Legacy Request'
//                                                     :
//                                                     (
//                                                         <ViewDynamicApprovalRemarks dynamic_approval={i?.dynamic_approval} />
//                                                     )
//                                                 }
//                                             </td>
//                                             {SUPER_ADMIN && <td className="align-right">
//                                                 {
//                                                     (i.rh_leave_status === "pending" || i?.rh_leave_status === 'rejected') && (
//                                                         <div className="flex-row align-center width-5vw">
//                                                             <DeleteCompoffShortLeaveForm i={i} getCompensatoryList={getLeaveLogList} />
//                                                         </div>
//                                                     )
//                                                 }
//                                             </td>}
//                                         </tr>
//                                     </React.Fragment>
//                                 ))}
//                             </tbody>
//                         )}
//                     </table>
//                 </div>
//             </div>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </>
//     );
// };


const EmployeeCompensatoryLogTable = ({ emp_code }) => {
    const { PORTAL_SETTINGS, SUPER_ADMIN, SUB_COMPANIES, PERMISSION_HR_ADMIN } = usePermission();
    const [buffer, setBuffering] = useState(true);
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");
    const [selectedStatus, setSelectedStatus] = useState("null");
    const [leaveLogList, setLeaveLogList] = useState([]);

    const getLeaveLogList = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/shortandcompoff/${fromdate}/${todate}/null/${selectedStatus}/${emp_code}/null/active/`
            );
            setLeaveLogList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getLeaveLogList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fromdate, todate, selectedStatus, emp_code]);

    return (
        <>
            <div className="attendance-history-cont">
                <div className="table-css-white-background">

                    {/* Header & Filter Section */}
                    {/* INLINE STYLE: Added flexWrap and gap so items don't squish on mobile */}
                    <div className="table-heading-flex" style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "15px" }}>
                        <div className="repo-heading font-weight500 font-size-heading" style={{ margin: 0 }}>
                            Employee Compensatory Logs
                        </div>

                        {/* INLINE STYLE: Added flexWrap so the dropdown and button stack if needed */}
                        <div className="field-cont" style={{ display: "flex", flexWrap: "wrap", gap: "10px", }}>

                            <div className="table-searchh dropdown-container field-cont-div" style={{ margin: 0, flexWrap: "nowrap" }}>
                                <Filter />
                                <select
                                    className="dropdown font-size-subheading"
                                    value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}
                                    // INLINE STYLE: Override fixed widths to be responsive
                                    style={{ width: "100%", minWidth: "120px", border: "none", background: "transparent", outline: "none", cursor: "pointer" }}
                                >
                                    <option value="null">All</option>
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>

                            {(!PORTAL_SETTINGS?.compoff_auto_apply || !PORTAL_SETTINGS?.shortleave_auto_apply) && (
                                <div className="btn-cont" style={{ width: 'max-content' }}>
                                    <AddCompoffShortLeaveForm
                                        getCompensatoryList={getLeaveLogList}
                                        SUPER_ADMIN={SUPER_ADMIN}
                                        SUB_COMPANIES={SUB_COMPANIES}
                                        EmpCode={emp_code}
                                        PERMISSION_HR_ADMIN={PERMISSION_HR_ADMIN}
                                        PORTAL_SETTINGS={PORTAL_SETTINGS}
                                    />
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Table Section */}
                    {/* INLINE STYLE: overflowX allows horizontal scrolling on mobile without breaking page layout */}
                    <div style={{ overflowX: "auto", width: "100%" }}>
                        {/* INLINE STYLE: minWidth prevents the columns from crushing together */}
                        <table className="table-css" style={{ width: "100%", minWidth: "900px" }}>
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="align-left">Sr.no</th>
                                    <th className="align-center">Date</th>
                                    <th className="align-center">Time (Work Duration)</th>
                                    <th className="align-center">Reporting Head</th>
                                    <th className="align-center">Leave Type</th>
                                    <th className="align-center">Request Status</th>
                                    <th className="align-center">Status</th>
                                    <th className="align-center">Remark</th>
                                    {SUPER_ADMIN && <th className="align-center">Action</th>}
                                </tr>
                            </thead>

                            {/* FIX: Render spinner and empty states INSIDE valid <tbody> and <tr> tags */}
                            <tbody>
                                {buffer ? (
                                    <tr>
                                        <td colSpan={SUPER_ADMIN ? 9 : 8} style={{ padding: "40px 0", textAlign: "center" }}>
                                            <div className="spinner" style={{ margin: "0 auto" }}></div>
                                        </td>
                                    </tr>
                                ) : leaveLogList.length === 0 ? (
                                    <tr>
                                        <td colSpan={SUPER_ADMIN ? 9 : 8} style={{ padding: "40px 0", textAlign: "center", color: "#707070" }}>
                                            No Compensatory Logs Found.
                                        </td>
                                    </tr>
                                ) : (
                                    leaveLogList.map((i, index) => (
                                        <tr key={index} className="custom-table-head-td" style={{ borderBottom: "1px solid #e8e8e8" }}>
                                            <td className="align-left">{index + 1}</td>
                                            <td className="align-center">{formattedDateLong(i.date)}</td>
                                            <td className="align-center">{i.in_time} - {i.out_time} ({i.work_duration})</td>
                                            <td className="align-center">{i.rh_assigned}</td>
                                            <td className="align-center text-capitalize">{i.duration}</td>
                                            <td className="align-center">
                                                <span request-status={i.rh_leave_status} className="request-status align-center">
                                                    {i.rh_leave_status === "pending"
                                                        ? "Pending For Rh Approval ⌛"
                                                        : i.rh_leave_status === "rejected"
                                                            ? "Rh Rejected ✖"
                                                            : "Rh Approved ✔"}
                                                </span>
                                            </td>
                                            <td className="align-center">
                                                {i.approval_flow_version === 0 ? (
                                                    'Legacy Request'
                                                ) : (
                                                    <ViewDynamicApprovalStatus dynamic_approval={i?.dynamic_approval} />
                                                )}
                                            </td>
                                            <td className="table-body align-center vertical-alignment-middle">
                                                {i?.approval_flow_version === 0 ? (
                                                    'Legacy Request'
                                                ) : (
                                                    <ViewDynamicApprovalRemarks dynamic_approval={i?.dynamic_approval} />
                                                )}
                                            </td>
                                            {SUPER_ADMIN && (
                                                <td className="align-center">
                                                    {(i.rh_leave_status === "pending" || i?.rh_leave_status === 'rejected') && (
                                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                            <DeleteCompoffShortLeaveForm i={i} getCompensatoryList={getLeaveLogList} />
                                                        </div>
                                                    )}
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const EmployeeNotificationLogTable = ({ emp_code }) => {
    const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
    const [checkedItems, setCheckedItems] = useState([]);
    // const [date, setDate] = useState();
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [employeeList, setEmployeeList] = useState([]);
    // const [date, setDate] = useState(`${formattedDate}`);
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");
    const [selectedStatus, setSelectedStatus] = useState("null");
    const [employeeGet, setEmployeeGet] = useState("null");
    const [active, setActive] = useState("active");
    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("company_id")}`
    );

    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err)
        }
    };

    // *********** Employee Details Api Start ***********
    const [leaveLogList, setLeaveLogList] = useState([]);
    const [filteredleaveLogList, setfilteredleaveLogList] = useState([]);

    const getEmpList = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedDivision}/`
            );
            const sortedData = customSortByKey(res.data, "emp_code");

            setEmployeeList(sortedData);
        } catch (err) {
            handleErrorToast(err)
        }
    };

    const getLeaveLogList = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/shortandcompoff/${fromdate}/${todate}/null/${selectedStatus}/${emp_code}/null/active/`
            );
            setLeaveLogList(res.data);
            // setOutdutyName(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    // *********** Employee Details Api End ***********

    useEffect(() => {
        getLeaveLogList();
        getEmpList();
        getSubCompany();
    }, [employeeGet, fromdate, todate, selectedStatus, active, selectedDivision]);

    useEffect(() => {
    }, []);

    return (
        <>
            <div className="attendance-history-cont">
                <div className="attendance-heading  font-weight500    font-size-heading"> </div>
                <div className="attendance-subcont">
                    <div className="field-cont">

                        <div className="field-cont-div">
                            <div className="date-uppercase ">
                                <input
                                    className="attendance-input-field width-10vw   date-field date-field-filter"
                                    placeholder="From Date"
                                    type="date"
                                    value={fromdate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                />
                            </div>
                            <hr className="field-cont-hr" />
                        </div>

                        <div className="field-cont-div">
                            <div className=" date-uppercase ">
                                <input
                                    className="attendance-input-field width-10vw   date-field date-field-filter"
                                    placeholder="From Date"
                                    type="date"
                                    value={todate}
                                    onChange={(e) => setToDate(e.target.value)}
                                />
                            </div>
                            <hr className="field-cont-hr" />

                        </div>

                        <div className="field-cont-div">
                            <CircularGrid />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                            >
                                <option value="null">All</option>

                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                            </select>
                            <hr className="field-cont-hr" />

                        </div>

                    </div>

                    <div className="btn-cont"></div>
                </div>

                <div className="table-css-white-background">
                    <div className="table-heading-flex">
                        <div className="repo-heading font-weight500    font-size-heading">Employee Notification Logs </div>
                    </div>
                    <table className="table-css">
                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="align-left">Sr.no</th>
                                <th className="align-center">Date - Time</th>
                                <th className="align-center">Leave Type</th>
                                <th className="align-center">Balance Before</th>
                                <th className="align-center">Leaves Affected</th>
                                <th className="align-center">Balance After</th>
                                <th className="align-center width-20vw">Description</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner"></div>
                        ) : (
                            <tbody>
                                {leaveLogList.map((i, index) => (
                                    <React.Fragment key={index}>
                                        <tr className="tr-border-bottom">
                                            <td colSpan="6"></td>
                                        </tr>
                                        <tr className="custom-table-head-td">
                                            <td className="align-left">{index + 1}</td>
                                            <td className="align-center">{formattedDateLong(i.date)}-{i.in_time}</td>
                                            <td className="align-center text-capitalize">{i.duration}</td>
                                            <td className="align-center">{i.out_time}</td>
                                            <td className="align-center">{i.work_duration}</td>
                                            <td className="align-center">{i.rh_assigned}</td>
                                            <td className="align-center text-capitalize">{i.duration}</td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

// const EmployeeBankDetailsChangeLogs = ({ emp_code }) => {

//     const [buffer, setBuffering] = useState(true);
//     const [changeLogList, setChangeLogList] = useState([]);
//     const [selectedStatus, setSelectedStatus] = useState("null");

//     const getBankDetailsChangeLogs = async () => {
//         setBuffering(true);
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/wfm/bank-details-log-by-emp/${emp_code}/${selectedStatus}/`
//             );
//             setChangeLogList(res.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false);
//         }
//     };

//     useEffect(() => {
//         getBankDetailsChangeLogs();
//     }, [emp_code, selectedStatus]);


//     return (
//         <>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick />
//             <div className="attendance-history-cont">
//                 <div className="attendance-subcont">
//                     <div className="field-cont">
//                         <div title="All" className="field-cont-div">
//                             <Filter />
//                             <select
//                                 className="attendance-input-field width-15vw date-field"
//                                 value={selectedStatus}
//                                 onChange={(e) => {
//                                     const value = e.target.value;
//                                     setSelectedStatus(value);
//                                 }}
//                                 style={{ cursor: "pointer" }}
//                             >
//                                 <option value="null">All Requests</option>
//                                 <option value="pending">In Process</option>
//                                 <option value="approved">Completed Requests</option>
//                             </select>
//                             <hr className="field-cont-hr" />
//                         </div>

//                     </div>
//                 </div>

//                 <div className="table-css-white-background scroll-container-table">
//                     <div className="table-heading-flex">
//                         <div className="repo-heading font-weight500 font-size-heading">Stage of Bank Details Change</div>
//                     </div>
//                     <table className="table-css">
//                         <thead className="table-heading stciky-heading-top">
//                             <tr className="custom-table-head-tr">
//                                 <th className="table-heading-text text-lefttt">S. No.</th>
//                                 <th className="table-heading-text align-center">Previous Details</th>
//                                 <th className="table-heading-text align-center">Requested Changes</th>
//                                 <th className="table-heading-text align-center">Changed Fields</th>
//                                 <th className="table-heading-text align-center">Proof</th>
//                                 <th className="table-heading-text align-center">Reason for Change</th>
//                                 <th className="table-heading-text">Status</th>
//                                 <th className="table-heading-text">Remarks</th>
//                                 <th className="table-heading-text">Action</th>
//                             </tr>
//                         </thead>
//                         {buffer ? (
//                             <div className="spinner-bgdatil"></div>
//                         ) : (
//                             <tbody>
//                                 {changeLogList.map((i, index) => {

//                                     return (
//                                         <tr key={i.id} className="custom-table-head-td">
//                                             <td className="table-body">{index + 1}</td>

//                                             {/* Previous Details */}
//                                             <td className="table-body">
//                                                 <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                                                     <tbody>
//                                                         {Object.entries(i.previous_data || {}).map(([key, value]) => (
//                                                             <tr key={key}>
//                                                                 <td className="table-body text-capitalize" style={{ paddingBottom: "5px" }}>
//                                                                     {FormatKey(key)}
//                                                                 </td>
//                                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                                 <td className="align-right">
//                                                                     {value}
//                                                                 </td>
//                                                             </tr>
//                                                         ))}
//                                                     </tbody>
//                                                 </table>
//                                             </td>

//                                             {/* Updated Details */}
//                                             <td className="table-body">
//                                                 <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                                                     <tbody>
//                                                         {Object.entries(i.updated_data || {}).map(([key, value]) => (
//                                                             <tr key={key}>
//                                                                 <td className="table-body text-capitalize" style={{ paddingBottom: "5px" }}>
//                                                                     {FormatKey(key)}
//                                                                 </td>
//                                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                                 <td className="align-right">
//                                                                     {value}
//                                                                 </td>
//                                                             </tr>
//                                                         ))}
//                                                     </tbody>
//                                                 </table>
//                                             </td>

//                                             {/* Changed Fields */}
//                                             <td className="table-body">
//                                                 {i.changed_fields?.length > 0 ? (
//                                                     <ul style={{ margin: 0, paddingLeft: "16px" }}>
//                                                         {i.changed_fields.map((field, idx) => (
//                                                             <li key={idx} className="text-capitalize">{FormatKey(field)}</li>
//                                                         ))}
//                                                     </ul>
//                                                 ) : (
//                                                     "-"
//                                                 )}
//                                             </td>
//                                             <td>
//                                                 {i?.proof_attachment ? (
//                                                     <ViewFile
//                                                         doc={i?.proof_attachment}
//                                                         filename={"Proof Attachment"}
//                                                         filesrc={i?.proof_attachment}
//                                                     />
//                                                 ) : (
//                                                     'No File Attached'
//                                                 )}
//                                             </td>

//                                             {/* Status */}
//                                             <td className="table-body">{i.reason_for_change || '-'}</td>

//                                             <ViewDynamicApprovalStatus dynamic_approval={i.dynamic_approval} />
//                                             <ViewDynamicApprovalRemarks dynamic_approval={i.dynamic_approval} />

//                                             <td className="table-body">
//                                                 {(Array.isArray(i?.dynamic_approval)) && (i.dynamic_approval?.every(status => status.approval_status === "pending")) && (
//                                                     <BankDetailChangeLogDelete
//                                                         getBankDetailsChangeLogs={getBankDetailsChangeLogs}
//                                                         empcode={i?.emp_code}
//                                                         id={i?.id}
//                                                     />
//                                                 )}
//                                             </td>

//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>
//                         )}
//                     </table>
//                 </div>
//             </div>
//         </>
//     );
// };

const EmployeeBankDetailsChangeLogs = ({ emp_code }) => {
    const [buffer, setBuffering] = useState(true);
    const [changeLogList, setChangeLogList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState("null");

    const getBankDetailsChangeLogs = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/bank-details-log-by-emp/${emp_code}/${selectedStatus}/`
            );
            setChangeLogList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getBankDetailsChangeLogs();
    }, [emp_code, selectedStatus]);

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick />

            <div className="attendance-history-cont">

                {/* 1. Responsive Filter Section */}
                <div className="attendance-subcont" style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', padding: '16px 20px' }}>
                    <div className="field-cont" style={{ width: '100%' }}>
                        <div title="Filter Status" className="field-cont-div" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Filter />
                            {/* Removed width-15vw to allow proper mobile flexing */}
                            <select
                                className="attendance-input-field"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                                style={{ cursor: "pointer", width: '100%', flex: 1, backgroundColor: '#f6f7f9', padding: '10px', borderRadius: '8px', border: 'none' }}
                            >
                                <option value="null">All Requests</option>
                                <option value="pending">In Process</option>
                                <option value="approved">Completed Requests</option>
                                <option value="rejected">Rejected</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* 2. Responsive Table Section */}
                <div className="table-css-white-background" style={{ overflowX: 'auto', width: '100%' }}>
                    <div className="table-heading-flex" style={{ marginBottom: '15px' }}>
                        <div className="repo-heading font-weight500 font-size-heading">Stage of Bank Details Change</div>
                    </div>

                    {/* Added minWidth to enforce horizontal scrolling on mobile instead of squishing columns */}
                    <table className="table-css" style={{ width: "100%", minWidth: "1000px" }}>
                        <thead className="table-heading stciky-heading-top">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text align-left">S. No.</th>
                                <th className="table-heading-text align-left">Previous Details</th>
                                <th className="table-heading-text align-left">Requested Changes</th>
                                <th className="table-heading-text align-left">Changed Fields</th>
                                <th className="table-heading-text align-center">Proof</th>
                                <th className="table-heading-text align-left">Reason for Change</th>
                                <th className="table-heading-text align-center">Status</th>
                                <th className="table-heading-text align-center">Remarks</th>
                                <th className="table-heading-text align-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* FIX: Moved the spinner inside a valid table row/cell structure */}
                            {buffer ? (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: "center", padding: "40px 0" }}>
                                        <div className="spinner-bgdatil" style={{ margin: "auto" }}></div>
                                    </td>
                                </tr>
                            ) : changeLogList.length === 0 ? (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: "center", padding: "40px 0", color: "#6B7280" }}>
                                        No bank detail change logs found.
                                    </td>
                                </tr>
                            ) : (
                                changeLogList.map((i, index) => (
                                    <tr key={i.id} className="custom-table-head-td">
                                        <td className="table-body align-left">{index + 1}</td>

                                        {/* Previous Details */}
                                        <td className="table-body align-left">
                                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                <tbody>
                                                    {Object.entries(i.previous_data || {}).map(([key, value]) => (
                                                        <tr key={key}>
                                                            <td className="text-capitalize" style={{ paddingBottom: "5px", color: "#6B7280", fontSize: "12px" }}>
                                                                {FormatKey(key)}
                                                            </td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-left font-weight500" style={{ fontSize: "13px" }}>
                                                                {value || "-"}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </td>

                                        {/* Updated Details */}
                                        <td className="table-body align-left">
                                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                <tbody>
                                                    {Object.entries(i.updated_data || {}).map(([key, value]) => (
                                                        <tr key={key}>
                                                            <td className="text-capitalize" style={{ paddingBottom: "5px", color: "#6B7280", fontSize: "12px" }}>
                                                                {FormatKey(key)}
                                                            </td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-left font-weight500" style={{ fontSize: "13px", color: "#2576bc" }}>
                                                                {value || "-"}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </td>

                                        {/* Changed Fields */}
                                        <td className="table-body align-left">
                                            {i.changed_fields?.length > 0 ? (
                                                <ul style={{ margin: 0, paddingLeft: "16px", color: "#374151" }}>
                                                    {i.changed_fields.map((field, idx) => (
                                                        <li key={idx} className="text-capitalize">{FormatKey(field)}</li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <span style={{ color: "#9CA3AF" }}>-</span>
                                            )}
                                        </td>

                                        {/* Proof */}
                                        <td className="align-center">
                                            {i?.proof_attachment ? (
                                                <ViewFile
                                                    doc={i?.proof_attachment}
                                                    filename={"Proof Attachment"}
                                                    filesrc={i?.proof_attachment}
                                                />
                                            ) : (
                                                <span style={{ color: "#9CA3AF", fontSize: "12px" }}>No File</span>
                                            )}
                                        </td>

                                        {/* Reason */}
                                        <td className="table-body align-left" style={{ maxWidth: "200px", whiteSpace: "normal" }}>
                                            {i.reason_for_change || <span style={{ color: "#9CA3AF" }}>-</span>}
                                        </td>

                                        {/* Status & Remarks (These components return a <td> internally) */}
                                        <ViewDynamicApprovalStatus dynamic_approval={i.dynamic_approval} />
                                        <ViewDynamicApprovalRemarks dynamic_approval={i.dynamic_approval} />

                                        {/* Action */}
                                        <td className="table-body align-center">
                                            {(Array.isArray(i?.dynamic_approval)) && (i.dynamic_approval?.every(status => status.approval_status === "pending")) ? (
                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <BankDetailChangeLogDelete
                                                        getBankDetailsChangeLogs={getBankDetailsChangeLogs}
                                                        empcode={i?.emp_code}
                                                        id={i?.id}
                                                    />
                                                </div>
                                            ) : (
                                                <span style={{ color: "#9CA3AF" }}>-</span>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

const EmployeeCompensatoryRequests = ({ emp_code }) => {
    const [date, setDate] = useState(`${formattedDate}`);
    const [startdate, setStartDate] = useState('null');
    const [enddate, setEndDate] = useState('null');
    const [selectedStatus, setSelectedStatus] = useState("null");
    const [employeeGet, setEmployeeGet] = useState("null");
    const [buffer, setBuffering] = useState(true); //buffering logic

    // *********** Employee Details Api Start ***********
    const [compensatoryList, setCompensatoryList] = useState([]);
    const [filteredCompensatoryList, setfilteredCompensatoryList] = useState([]);


    const getCompensatoryList = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/shortandcompoff/${startdate}/${enddate}/null/${selectedStatus}/${emp_code}/null/active/`
            );
            setCompensatoryList(res.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    // *********** Employee Details Api End ***********

    useEffect(() => {
        getCompensatoryList();
    }, [date, startdate, enddate, selectedStatus]);

    return (
        <>
            <div className="attendance-history-cont">
                <div className="attendance-heading  font-weight500    font-size-heading"> </div>
                <div className="attendance-subcont">
                    <div className="field-cont">
                        <div title='Date Range' className="field-cont-div ">
                            <DateRangePicker startDate={startdate} endDate={enddate} placeHolder1="From Date" placeHolder2="To Date" onChange={(start, end) => {
                                setStartDate(start || 'null');
                                setEndDate(end || 'null');
                            }} />
                            <hr className="field-cont-hr" />
                        </div>

                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                            >
                                <option value="null">All</option>

                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                    </div>

                    <div className="btn-cont"></div>
                </div>

                <div className="table-css-white-background">
                    <div className="table-heading-flex">
                        <div className="repo-heading font-weight500    font-size-heading">Compensatory leaves </div>
                    </div>
                    <table className="table-css">
                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="align-left">Sr.no</th>
                                <th className="align-center">Date</th>
                                <th className="align-center">In-Time</th>
                                <th className="align-center">Out-Time</th>
                                <th className="align-center">Working Hours</th>
                                <th className="align-center">Compensatory Type</th>
                                <th className="align-center">Request Status</th>
                                <th className="align-center ">Status</th>
                                <th className="align-center ">Remark</th>
                            </tr>
                        </thead>
                        {buffer ? <div className="spinner"></div> : //buffering logic
                            <tbody>
                                {compensatoryList.map((i, index) => (
                                    <React.Fragment key={index}>
                                        <tr className="tr-border-bottom">
                                            <td colSpan="6"></td>
                                        </tr>
                                        <tr className="custom-table-head-td">
                                            <td className="align-left">{index + 1}</td>

                                            <td className="align-center">
                                                {formattedDateLong(i.date)}
                                            </td>
                                            <td className="align-center">{i.in_time}</td>
                                            <td className="align-center">{i.out_time}</td>
                                            <td className="align-center">{i.work_duration}</td>
                                            <td className="align-center text-capitalize">
                                                {i.duration}
                                            </td>
                                            <td className="align-center">
                                                {i.approval_flow_version === 0
                                                    ? 'Legacy Request'
                                                    : '-'
                                                }
                                            </td>
                                            <td className="align-center">
                                                {i.approval_flow_version === 0
                                                    ?
                                                    <span
                                                        request-status={i.rh_leave_status}
                                                        className="request-status align-center"
                                                    >
                                                        {i.rh_leave_status === "pending"
                                                            ? "Pending For Rh Approval ⌛"
                                                            : i.rh_leave_status === "rejected"
                                                                ? "Rh Rejected ✖, "
                                                                : "Rh Approved ✔, "}
                                                    </span>
                                                    :
                                                    (
                                                        <ViewDynamicApprovalStatus dynamic_approval={i?.dynamic_approval} />

                                                    )
                                                }

                                                {/* <br />
                      <span request-status={i.admin_leave_status} className="request-status align-center" >{(i.rh_leave_status === "rejected" && i.admin_leave_status === "rejected") ? "Admin Rejected ✖, " : (i.rh_leave_status === "approved" && i.admin_leave_status === "pending") ? "Pending For Admin Approval ⌛," : (i.rh_leave_status === "approved" && i.admin_leave_status === "rejected") ? "Admin Rejected ✖, " : (i.rh_leave_status === "approved" && i.admin_leave_status === "approved") ? "Admin Approved ✔, " : ""}</span> */}
                                            </td>
                                            <td className="table-body width-15vw align-center vertical-alignment-middle" >
                                                {i?.approval_flow_version === 0 ? (i.reason || '-')
                                                    :
                                                    (
                                                        <ViewDynamicApprovalRemarks dynamic_approval={i?.dynamic_approval} />
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        }
                    </table>
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const EmployeeQuickAppraisalTable = ({ isHOD, emp_code }) => {
    const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();

    const [loading, setLoading] = useState(true);
    const [timeStampView, setTimeStampView] = useState(false);

    const [selectedSubCompany, setSelectedSubCompany] = useState(sessionStorage.getItem("company_id"));
    const [ratingPeriod, setRatingPeriod] = useState("null");

    const [ratingPeriods, setRatingPeriods] = useState([]);
    const [appraisalData, setAppraisalData] = useState([]);

    const tableRef = useRef(null);

    // ===== Fetch Functions =====
    const fetchRatingPeriods = async () => {
        setLoading(true);
        try {
            // const res = await axios.get(`(${BASE_URL}/wfm/appraisal-quickform-setup-by-subcompany/${selectedSubCompany}/`);
            const res = await axios.get(`${BASE_URL}/wfm/appraisal-quickform-setup-by-subcompany/${selectedSubCompany}/`);
            const activeSetup = res.data.find(r => r.is_active);
            if (activeSetup) {
                setRatingPeriod(activeSetup.id);
            }
            setRatingPeriods(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchAppraisalData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/quick-appraisaldetails-byfilters/${selectedSubCompany}/${ratingPeriod}/${emp_code}/`);
            const sorted = customSortByKey(res.data.data || res.data, "emp_code");
            setAppraisalData(sorted);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRatingPeriods();
    }, [selectedSubCompany]);

    useEffect(() => {
        fetchAppraisalData();
    }, [selectedSubCompany, ratingPeriod, emp_code]);

    // ===== Download Excel =====
    const handleDownload = () => {
        downloadAsExcel(tableRef, "employee_appraisal", "EmployeeAppraisalSheet");
    };

    // ===== Render =====
    return (
        <div className="employee-appraisal-cont">

            <div className="table-css-white-background">
                <div className="table-heading-flex" style={{ flexWrap: "wrap" }}>
                    <div className="repo-heading font-weight500 font-size-heading">
                        {/* Quick Appraisals ({appraisalData.length}) */}
                        Appraisals Raitings
                    </div>
                    <div className="field-cont">
                        <select
                            className="dropdown font-size-subheading  "
                            value={ratingPeriod}
                            onChange={(e) => setRatingPeriod(e.target.value)}
                        >
                            <option value="null">All Rating Periods</option>
                            {ratingPeriods
                                ?.sort((a, b) => new Date(b.rating_period_start) - new Date(a.rating_period_start))
                                .map((r) => (
                                    <option key={r.id} value={r.id}>
                                        {formattedDateLong(r.rating_period_start)} - {formattedDateLong(r.rating_period_end)}
                                    </option>
                                ))}
                        </select>
                        {/* <div className="btn-cont">
                            <button className="model-button-print" onClick={handleDownload}>
                                <DownloadIcon /> Download Excel
                            </button>
                        </div> */}

                    </div>
                </div>

                {loading ? (
                    <div className="spinner"></div>
                ) : (
                    <table ref={tableRef} className="table-css">
                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="align-left">Sr. No</th>
                                <th className="align-center">Rating Period</th>
                                <th className="align-center">Self Rating</th>
                                {timeStampView && <th className="align-center">Self Timestamp</th>}
                                {/* {!isHOD && <th className="align-center">RH Rating</th>}
                                {!isHOD && <th className="align-center">RH Submission</th>}
                                {timeStampView && !isHOD && <th className="align-center">RH Timestamp</th>}
                                <th className="align-center">HOD Rating</th>
                                <th className="align-center">HOD Submission</th>
                                {timeStampView && <th className="align-center">HOD Timestamp</th>}
                                <th className="align-center">Admin Rating</th>
                                <th className="align-center">Admin Submission</th>
                                {timeStampView && <th className="align-center">Admin Timestamp</th>} */}
                                <th className="align-center">Final Rating</th>
                                <th className="align-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {appraisalData.map((i, idx) => (
                                <React.Fragment key={idx}>
                                    <tr className="tr-border-bottom"><td colSpan="14"></td></tr>
                                    <tr className="custom-table-head-td">
                                        <td className="align-left flex-row">{idx + 1}</td>
                                        <td className="align-center">{formattedDateLong(i.rating_period_start)} - {formattedDateLong(i.rating_period_end)}
                                            <br />
                                            {i.is_active === true || i.is_active === 'True' ?
                                                <button className="priority-button color-tab-green">
                                                    Active
                                                </button>
                                                : null}
                                        </td>
                                        <td className="align-center">{i.total_emp || '-'}</td>
                                        {timeStampView && <td className="align-center">{i.emp_update_datetime ? formatDateTime(i.emp_update_datetime).full : '-'}</td>}
                                        {/* {!isHOD && <td className="align-center">{i.total_rh || '-'}</td>}
                                        {!isHOD && <td className="align-center">{i.rh_update_by || '-'}</td>}
                                        {timeStampView && !isHOD && <td className="align-center">{i.rh_update_datetime ? formatDateTime(i.rh_update_datetime).full : '-'}</td>}
                                        <td className="align-center">{i.total_hod || '-'}</td>
                                        <td className="align-center">{i.hod_update_by || '-'}</td>
                                        {timeStampView && <td className="align-center">{i.hod_update_datetime ? formatDateTime(i.hod_update_datetime).full : '-'}</td>}
                                        <td className="align-center">{i.total_admin || '-'}</td>
                                        <td className="align-center">{i.admin_update_by || '-'}</td>
                                        {timeStampView && <td className="align-center">{i.admin_update_datetime ? formatDateTime(i.admin_update_datetime).full : '-'}</td>} */}
                                        <td className="align-center">{i.final_rating || '-'}</td>
                                        <td className="align-center">
                                            <div className=" flex-row justify-center">
                                                <ViewAppraisalDetailsByEmployee i={i} display_flag={true} />
                                            </div>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};



const MEDALS = {
    1: { bg: "#fef3c7", fg: "#b45309", ring: "#fcd34d" },
    2: { bg: "#e2e8f0", fg: "#475569", ring: "#cbd5e1" },
    3: { bg: "#ffedd5", fg: "#c2410c", ring: "#fdba74" },
};

// const StarRankingList = ({ emp_code, initialStart, initialEnd }) => {
//     const subCompany = sessionStorage.getItem("company_id");
//     const defaultMonth = getCurrentMonthYear(); // expected "YYYY-MM"

//     // Stored as "YYYY-MM-01" for the picker; sliced to "YYYY-MM" for the API
//     const [startdate, setStartDate] = useState(`${initialStart || defaultMonth}-01`);
//     const [enddate, setEndDate] = useState(`${initialEnd || defaultMonth}-01`);
//     const [deptFilter, setDeptFilter] = useState("null");
//     const [search, setSearch] = useState("");

//     const [departments, setDepartments] = useState([]);
//     const [employees, setEmployees] = useState([]);
//     const [totalMarks, setTotalMarks] = useState(30);
//     const [loading, setLoading] = useState(false);

//     // Departments for the filter
//     useEffect(() => {
//         if (!subCompany || subCompany === "null") return;
//         axios
//             .get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${subCompany}/active/`)
//             .then((res) => setDepartments(res.data || []))
//             .catch((err) => console.error("Failed to load departments", err));
//     }, [subCompany]);

//     // Ranking data
//     useEffect(() => {
//         if (!subCompany || subCompany === "null") return;
//         if (!startdate || !enddate || startdate === "null" || enddate === "null") return;

//         let cancelled = false;
//         const fetchRanking = async () => {
//             setLoading(true);
//             try {
//                 const params = {
//                     sub_company: subCompany,
//                     start_month_year: startdate.slice(0, 7),
//                     end_month_year: enddate.slice(0, 7),
//                     sort_order: "high_to_low",
//                     employee_status: "active",
//                 };
//                 if (deptFilter !== "null") params.department_id = deptFilter;

//                 const res = await axios.get(`${BASE_URL}/wfm/star-performance-overall-rating/`, { params });
//                 if (cancelled) return;
//                 setEmployees(res.data?.employees || []);
//                 setTotalMarks(Number(res.data?.overall_total_marks) || 30);
//             } catch (err) {
//                 console.error("Failed to load star ranking", err);
//                 if (!cancelled) setEmployees([]);
//             } finally {
//                 if (!cancelled) setLoading(false);
//             }
//         };
//         fetchRanking();
//         return () => { cancelled = true; };
//     }, [subCompany, deptFilter, startdate, enddate]);

//     const filtered = useMemo(() => {
//         const q = search.trim().toLowerCase();
//         if (!q) return employees;
//         return employees.filter((e) =>
//             [e.name, /* e.empcode, */ e.designation_name].some((v) => String(v || "").toLowerCase().includes(q))
//         );
//     }, [employees, search]);

//     const me = employees.find((e) => e.empcode === emp_code);

//     // Renders 5 stars, rounding UP to the nearest 0.5 (e.g., 4.1 becomes 4.5)
//     const renderStars = (finalMarks, maxMarks, idPrefix, size = 20) => {
//         // 1. Calculate exact proportional score out of 5
//         const exactScoreOutOf5 = Math.min(Number(finalMarks || 0) / (maxMarks / 5), 5);

//         // 2. Round UP to nearest 0.5 step
//         const scoreOutOf5 = Math.ceil(exactScoreOutOf5 * 2) / 2;

//         return (
//             <div style={{ display: "flex", gap: "2px", alignItems: "center", justifyContent: "center" }}>
//                 {[1, 2, 3, 4, 5].map((index) => {
//                     let fill = 0;

//                     // Full star
//                     if (scoreOutOf5 >= index) {
//                         fill = 100;
//                     }
//                     // Half star
//                     else if (scoreOutOf5 > index - 1) {
//                         fill = 50;
//                     }

//                     return (
//                         <StarIcon
//                             key={index}
//                             id={`${idPrefix}-${index}`}
//                             fillPercentage={fill}
//                             size={size}
//                         />
//                     );
//                 })}
//             </div>
//         );
//     };

//     const renderRow = (emp) => {
//         const rank = emp.sub_company_rank;
//         const medal = MEDALS[rank];
//         const isMe = emp.empcode === emp_code;
//         const marks = Number(emp.overall_final_marks || 0);

//         return (
//             <div
//                 key={emp.empcode}
//                 style={{
//                     display: "flex", flexDirection: "column", alignItems: "center", gap: "10px",
//                     padding: "16px", borderRadius: "12px",
//                     border: `1px solid ${isMe ? "#bfdbfe" : "#f1f5f9"}`,
//                     background: isMe ? "#eff6ff" : "#ffffff",
//                     boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
//                     position: "relative",
//                     transition: "transform 0.2s, box-shadow 0.2s"
//                 }}
//                 onMouseEnter={(e) => {
//                     e.currentTarget.style.transform = "translateY(-2px)";
//                     e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.05)";
//                 }}
//                 onMouseLeave={(e) => {
//                     e.currentTarget.style.transform = "translateY(0)";
//                     e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.05)";
//                 }}
//             >
//                 {/* Rank badge (Absolute top right) */}
//                 <div style={{ position: "absolute", top: "12px", right: "12px" }}>
//                     <div
//                         style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "4px",
//                             padding: "4px 8px",
//                             borderRadius: "999px",
//                             background: medal ? medal.bg : "#f8fafc",
//                             color: medal ? medal.fg : "#64748b",
//                             border: `1.5px solid ${medal ? medal.ring : "#e2e8f0"}`,
//                             justifyContent: "center",
//                         }}
//                     >
//                         <span style={{ fontSize: "9px", fontWeight: 700, opacity: 0.75, letterSpacing: "0.4px" }}>
//                             RANK
//                         </span>
//                         <span style={{ fontSize: "12px", fontWeight: 800, lineHeight: 1 }}>
//                             {getOrdinal(rank) || "-"}
//                         </span>
//                     </div>
//                 </div>

//                 {/* Avatar */}
//                 <div style={{ marginTop: "12px" }}>
//                     <CustomImageModal customStyle>
//                         {emp.profilepic ? (
//                             <img
//                                 src={`${IMAGE_URL}${emp.profilepic}`}
//                                 className="profile-img"
//                                 alt={emp?.name}
//                                 style={{ width: "64px", height: "64px", borderRadius: "50%", objectFit: "cover" }}
//                             />
//                         ) : (
//                             <UserDefaultLogo
//                                 user={{ name: emp.name, profilepic: "" }}
//                                 customStyleforParent={"reqOutDuty-default-logo"}
//                                 customStyleforChild={"small-profile"}
//                             />
//                         )}
//                     </CustomImageModal>
//                 </div>

//                 {/* Info */}
//                 <div style={{ textAlign: "center", minWidth: 0, width: "100%" }}>
//                     <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
//                         <span
//                             style={{
//                                 fontSize: "14px", fontWeight: 600, color: "#1e293b",
//                                 lineHeight: 1.2, overflow: "hidden",
//                                 textOverflow: "ellipsis", whiteSpace: "nowrap",
//                             }}
//                             title={emp.name}
//                         >
//                             {emp.name}
//                         </span>
//                         {isMe && (
//                             <span
//                                 style={{
//                                     fontSize: "10px", fontWeight: 700, color: "#1d4ed8",
//                                     background: "#dbeafe", padding: "2px 8px", borderRadius: "999px",
//                                 }}
//                             >
//                                 You
//                             </span>
//                         )}
//                     </div>
//                     <div
//                         style={{
//                             fontSize: "12px", color: "#64748b", overflow: "hidden",
//                             textOverflow: "ellipsis", whiteSpace: "nowrap", marginTop: "4px"
//                         }}
//                         title={emp.designation_name}
//                     >
//                         {emp.designation_name}
//                     </div>
//                 </div>

//                 {/* Stars and Overall Rating */}
//                 <div style={{ flexShrink: 0, marginTop: "4px", display: "flex", alignItems: "center", gap: "8px" }}>
//                     {renderStars(marks, totalMarks, emp.empcode)}
//                     <span style={{ fontSize: "12px", fontWeight: "700", color: "#0f172a", minWidth: "40px", textAlign: "right" }}>
//                         {Number(emp.overall_final_marks || 0).toFixed(1)} / {totalMarks}
//                     </span>
//                 </div>
//             </div>
//         );
//     };

//     return (
//         <div style={{ background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "16px", padding: "20px", display: "flex", flexDirection: "column", gap: "16px" }}>

//             {/* Header + filters */}
//             <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
//                 <div>
//                     <div style={{ fontSize: "16px", fontWeight: 700, color: "#0f172a" }}>Star ranking</div>
//                     <div style={{ fontSize: "12px", color: "#64748b", marginTop: "2px" }}>
//                         Employees ranked by overall star score for the selected months
//                     </div>
//                 </div>

//                 <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "10px" }}>
//                     <MonthRangePicker
//                         startDate={startdate}
//                         endDate={enddate}
//                         placeHolder1="Start Month"
//                         placeHolder2="End Month"
//                         maxMonth={dayjs().add(1, "month")}
//                         onChange={(start, end) => {
//                             setStartDate(start || "null");
//                             setEndDate(end || "null");
//                         }}
//                     />
//                     <div className="field-cont-div">
//                         <CircularGrid />
//                         <select
//                             className="attendance-input-field width-10vw date-field"
//                             value={deptFilter}
//                             onChange={(e) => setDeptFilter(e.target.value || "null")}
//                         >
//                             <option value="null">All Department</option>
//                             {departments
//                                 .slice()
//                                 .sort((a, b) => a.title.localeCompare(b.title))
//                                 .map((d) => (
//                                     <option key={d.id} value={String(d.id)}>{d.title}</option>
//                                 ))}
//                         </select>
//                     </div>
//                 </div>
//             </div>

//             {/* Summary strip */}
//             <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
//                 {me && (
//                     <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 14px", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: "12px" }}>
//                         <span style={{ fontSize: "12px", fontWeight: 600, color: "#1d4ed8" }}>Your company rank</span>
//                         <span style={{ fontSize: "18px", fontWeight: 800, color: "#0f172a" }}>{getOrdinal(me.sub_company_rank)}</span>
//                     </div>
//                 )}
//                 {/* <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 14px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "12px" }}>
//                     <span style={{ fontSize: "12px", fontWeight: 600, color: "#64748b" }}>Employees listed</span>
//                     <span style={{ fontSize: "18px", fontWeight: 800, color: "#0f172a" }}>{filtered.length}</span>
//                 </div> */}

//                 <input
//                     type="text"
//                     value={search}
//                     onChange={(e) => setSearch(e.target.value)}
//                     placeholder="Search by name or designation"
//                     style={{ marginLeft: "auto", flex: "0 1 280px", minWidth: "200px", padding: "10px 14px", border: "1px solid #e2e8f0", borderRadius: "12px", fontSize: "13px", outline: "none" }}
//                 />
//             </div>

//             {/* Grid */}
//             <div style={{ maxHeight: "60vh", minHeight: "240px", overflowY: "auto", display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "16px", paddingRight: "4px", paddingBottom: "16px" }}>
//                 {loading ? (
//                     <div style={{ minHeight: "240px", display: "flex", alignItems: "center", justifyContent: "center", gridColumn: "1 / -1" }}>
//                         <Loader container={true} />
//                     </div>
//                 ) : filtered.length === 0 ? (
//                     <div style={{ textAlign: "center", padding: "40px 20px", color: "#64748b", fontSize: "13px", gridColumn: "1 / -1" }}>
//                         {search
//                             ? "No employees match your search. Try a different name or clear the search."
//                             : "No ranking data for these months. Try a different month range or department."}
//                     </div>
//                 ) : (
//                     filtered.map(renderRow)
//                 )}
//             </div>
//         </div>
//     );
// };

const StarRankingList = ({ emp_code, initialStart, initialEnd }) => {
    const subCompany = sessionStorage.getItem("company_id");
    const defaultMonth = getCurrentMonthYear(); // expected "YYYY-MM"

    // Stored as "YYYY-MM-01" for the picker; sliced to "YYYY-MM" for the API
    const [startdate, setStartDate] = useState(`${initialStart || defaultMonth}-01`);
    const [enddate, setEndDate] = useState(`${initialEnd || defaultMonth}-01`);
    const [deptFilter, setDeptFilter] = useState("null");
    const [search, setSearch] = useState("");

    const [departments, setDepartments] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [totalMarks, setTotalMarks] = useState(30);
    const [loading, setLoading] = useState(false);

    const [collapsedRanks, setCollapsedRanks] = useState({});

    const toggleRank = (rank) => {
        setCollapsedRanks((prev) => ({
            ...prev,
            [rank]: !prev[rank]
        }));
    };

    // Departments for the filter
    useEffect(() => {
        if (!subCompany || subCompany === "null") return;
        axios
            .get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${subCompany}/active/`)
            .then((res) => setDepartments(res.data || []))
            .catch((err) => console.error("Failed to load departments", err));
    }, [subCompany]);

    // Ranking data
    useEffect(() => {
        if (!subCompany || subCompany === "null") return;
        if (!startdate || !enddate || startdate === "null" || enddate === "null") return;

        let cancelled = false;
        const fetchRanking = async () => {
            setLoading(true);
            try {
                const params = {
                    sub_company: subCompany,
                    start_month_year: startdate.slice(0, 7),
                    end_month_year: enddate.slice(0, 7),
                    sort_order: "high_to_low",
                    employee_status: "active",
                };
                if (deptFilter !== "null") params.department_id = deptFilter;

                const res = await axios.get(`${BASE_URL}/wfm/star-performance-overall-rating/`, { params });
                if (cancelled) return;
                setEmployees(res.data?.employees || []);
                setTotalMarks(Number(res.data?.overall_total_marks) || 30);
            } catch (err) {
                console.error("Failed to load star ranking", err);
                if (!cancelled) setEmployees([]);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        fetchRanking();
        return () => { cancelled = true; };
    }, [subCompany, deptFilter, startdate, enddate]);

    // 1. Filter the employees first
    const filtered = useMemo(() => {
        const q = search.trim().toLowerCase();
        if (!q) return employees;
        return employees.filter((e) =>
            [e.name, /* e.empcode, */ e.designation_name].some((v) => String(v || "").toLowerCase().includes(q))
        );
    }, [employees, search]);

    // 2. Group the filtered employees by rank
    const groupedEmployees = useMemo(() => {
        const groups = filtered.reduce((acc, emp) => {
            const rank = emp.sub_company_rank || 0;
            if (!acc[rank]) acc[rank] = [];
            acc[rank].push(emp);
            return acc;
        }, {});

        // Sort by rank number ascending (Rank 1, Rank 2, etc.)
        return Object.keys(groups)
            .sort((a, b) => Number(a) - Number(b))
            .map((rank) => ({
                rank: Number(rank),
                employees: groups[rank],
            }));
    }, [filtered]);

    const me = employees.find((e) => e.empcode === emp_code);

    // Renders 5 stars, rounding UP to the nearest 0.5 (e.g., 4.1 becomes 4.5)
    const renderStars = (finalMarks, maxMarks, idPrefix, size = 20) => {
        const exactScoreOutOf5 = Math.min(Number(finalMarks || 0) / (maxMarks / 5), 5);
        const scoreOutOf5 = Math.ceil(exactScoreOutOf5 * 2) / 2;

        return (
            <div style={{ display: "flex", gap: "2px", alignItems: "center", justifyContent: "center" }}>
                {[1, 2, 3, 4, 5].map((index) => {
                    let fill = 0;
                    if (scoreOutOf5 >= index) fill = 100;
                    else if (scoreOutOf5 > index - 1) fill = 50;

                    return (
                        <StarIcon
                            key={index}
                            id={`${idPrefix}-${index}`}
                            fillPercentage={fill}
                            size={size}
                        />
                    );
                })}
            </div>
        );
    };

    // Renamed from renderRow to renderCard since it represents one person
    const renderCard = (emp) => {
        const isMe = emp.empcode === emp_code;
        const marks = Number(emp.overall_final_marks || 0);

        return (
            <div
                key={emp.empcode}
                style={{
                    width: "260px", // Increased width to give text more room
                    display: "flex",
                    flexDirection: "row", // Horizontal layout
                    alignItems: "center",
                    gap: "16px",
                    padding: "16px 20px",
                    borderRadius: "12px",
                    // Tinted the border slightly blue to match the theme
                    border: `1px solid ${isMe ? "#bfdbfe" : "rgba(25, 100, 160, 0.1)"}`,
                    background: isMe ? "#eff6ff" : "#ffffff",
                    // Base blue shadow matching the portal header
                    boxShadow: "0 4px 14px rgba(25, 100, 160, 0.12)",
                    transition: "transform 0.2s, box-shadow 0.2s"
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.05)";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.05)";
                }}
            >
                {/* Avatar - Left Aligned */}
                <div style={{ flexShrink: 0 }}>
                    <CustomImageModal customStyle>
                        {emp.profilepic ? (
                            <img
                                src={`${IMAGE_URL}${emp.profilepic}`}
                                className="profile-img"
                                alt={emp?.name}
                                style={{ width: "48px", height: "48px", borderRadius: "50%", objectFit: "cover" }}
                            />
                        ) : (
                            <UserDefaultLogo
                                user={{ name: emp.name, profilepic: "" }}
                                customStyleforParent={"reqOutDuty-default-logo"}
                                customStyleforChild={"small-profile"}
                            />
                        )}
                    </CustomImageModal>
                </div>

                {/* Info Container - Takes up middle space and allows wrapping */}
                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "4px", minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <span
                            style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                color: "#4e545d",
                                textTransform: "uppercase",
                                lineHeight: 1.2,
                                wordWrap: "break-word" // Allows full name to wrap to next line if very long
                            }}
                        >
                            {emp.name}
                        </span>
                        {isMe && (
                            <span
                                style={{
                                    fontSize: "10px", fontWeight: 700, color: "#1d4ed8",
                                    background: "#dbeafe", padding: "2px 8px", borderRadius: "999px",
                                    flexShrink: 0
                                }}
                            >
                                You
                            </span>
                        )}
                    </div>
                    <div
                        style={{
                            fontSize: "13px",
                            color: "#64748b",
                            lineHeight: 1.2,
                            wordWrap: "break-word" // Allows designation to wrap to next line
                        }}
                    >
                        {emp.designation_name}
                    </div>
                </div>

                {/* Score and Stars - Right Aligned */}
                <div style={{ flexShrink: 0, display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "8px" }}>
                    <span style={{ fontSize: "15px", fontWeight: "800", color: "#404654" }}>
                        {Number(emp.overall_final_marks || 0).toFixed(1)} / {totalMarks}
                    </span>
                    {/* Render stars slightly smaller to fit the layout nicely */}
                    {renderStars(marks, totalMarks, emp.empcode, 12)}
                </div>
            </div>
        );
    };

    return (
        <div style={{ background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "16px", padding: "20px", display: "flex", flexDirection: "column", gap: "16px" }}>

            {/* Header + filters */}
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
                <div>
                    <div style={{ fontSize: "16px", fontWeight: 700, color: "#0f172a" }}>Star ranking</div>
                    <div style={{ fontSize: "12px", color: "#64748b", marginTop: "2px" }}>
                        Employees ranked by overall star score for the selected months
                    </div>
                </div>

                <input
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search by name or designation"
                    style={{ marginLeft: "auto", flex: "0 1 280px", minWidth: "200px", padding: "10px 14px", border: "1px solid #e2e8f0", borderRadius: "12px", fontSize: "13px", outline: "none" }}
                />

                <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "10px" }}>
                    <MonthRangePicker
                        startDate={startdate}
                        endDate={enddate}
                        placeHolder1="Start Month"
                        placeHolder2="End Month"
                        maxMonth={dayjs().add(1, "month")}
                        onChange={(start, end) => {
                            setStartDate(start || "null");
                            setEndDate(end || "null");
                        }}
                    />
                    <div className="field-cont-div">
                        <CircularGrid />
                        <select
                            className="attendance-input-field width-10vw date-field"
                            value={deptFilter}
                            onChange={(e) => setDeptFilter(e.target.value || "null")}
                        >
                            <option value="null">All Department</option>
                            {departments
                                .slice()
                                .sort((a, b) => a.title.localeCompare(b.title))
                                .map((d) => (
                                    <option key={d.id} value={String(d.id)}>{d.title}</option>
                                ))}
                        </select>
                    </div>
                </div>
            </div>

            {/* Summary strip */}
            {/* <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
                {me && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 14px", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: "12px" }}>
                        <span style={{ fontSize: "12px", fontWeight: 600, color: "#1d4ed8" }}>Your company rank</span>
                        <span style={{ fontSize: "18px", fontWeight: 800, color: "#0f172a" }}>{getOrdinal(me.sub_company_rank)}</span>
                    </div>
                )}

                <input
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search by name or designation"
                    style={{ marginLeft: "auto", flex: "0 1 280px", minWidth: "200px", padding: "10px 14px", border: "1px solid #e2e8f0", borderRadius: "12px", fontSize: "13px", outline: "none" }}
                />
            </div> */}

            {/* Grid Area */}
            <div style={{ maxHeight: "60vh", minHeight: "240px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "24px", paddingRight: "4px", paddingBottom: "16px" }}>
                {loading ? (
                    <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Loader container={true} />
                    </div>
                ) : groupedEmployees.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "40px 20px", color: "#64748b", fontSize: "13px" }}>
                        {search
                            ? "No employees match your search. Try a different name or clear the search."
                            : "No ranking data for these months. Try a different month range or department."}
                    </div>
                ) : (
                    groupedEmployees.map((group) => {
                        const isCollapsed = collapsedRanks[group.rank];

                        return (
                            <div key={`rank-group-${group.rank}`} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                                {/* Horizontal Line with Rank Title and Collapse Icon */}
                                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                    {/* Left Curved Line */}
                                    <div style={{ flex: 1, height: "2px", background: "#cbd5e1", borderRadius: "10px" }} />

                                    {/* Clickable Center Area */}
                                    <div
                                        onClick={() => toggleRank(group.rank)}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                            cursor: "pointer",
                                            userSelect: "none",
                                            padding: "4px 8px",
                                            borderRadius: "8px"
                                        }}
                                        title={isCollapsed ? "Expand" : "Collapse"}
                                    >
                                        <span style={{ fontSize: "12px", fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                                            {getOrdinal(group.rank)} Rank
                                        </span>

                                        {/* Simple SVG chevron icon */}
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            style={{
                                                color: "#64748b",
                                                transform: isCollapsed ? "rotate(-180deg)" : "rotate(0deg)",
                                                transition: "transform 0.5s ease-in-out"
                                            }}
                                        >
                                            <polyline points="6 9 12 15 18 9"></polyline>
                                        </svg>
                                    </div>

                                    {/* Right Curved Line */}
                                    <div style={{ flex: 1, height: "2px", background: "#cbd5e1", borderRadius: "10px" }} />
                                </div>

                                {/* Inner Flex Container for Employees (Hidden if Collapsed) */}
                                {!isCollapsed && (
                                    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "16px" }}>
                                        {group.employees.map(renderCard)}
                                    </div>
                                )}
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};


export {
    EmployeeCompensatoryRequests,
    EmployeeCompensatoryLogTable,
    EmployeeNotificationLogTable,
    EmployeeBankDetailsChangeLogs,
    EmployeeQuickAppraisalTable,
    StarRankingList
};
